import { useRouter } from "next/router";
import useSearchParams from "@/hooks/useSearchParams";
import { useCallback, useMemo } from "react";
const couponFilterQueryKey = {
    SUBJECT: "subject",
    CATEGORY: "category"
};
const useCouponFilter = ()=>{
    const { query , push , pathname  } = useRouter();
    const searchParams = useSearchParams();
    const subject = useMemo(()=>{
        return searchParams.get(couponFilterQueryKey.SUBJECT);
    }, [
        searchParams
    ]);
    const handleSubject = useCallback((subject)=>{
        navigateFilter({
            [couponFilterQueryKey.SUBJECT]: subject,
            // 카테고리 초기화
            [couponFilterQueryKey.CATEGORY]: undefined
        });
    }, [
        searchParams
    ]);
    const category = useMemo(()=>{
        return searchParams.get(couponFilterQueryKey.CATEGORY);
    }, [
        searchParams
    ]);
    const handleCategory = useCallback((category)=>{
        navigateFilter({
            [couponFilterQueryKey.CATEGORY]: category
        });
    }, [
        searchParams
    ]);
    const navigateFilter = useCallback((newQuery)=>{
        push({
            pathname,
            query: {
                ...query,
                ...newQuery
            }
        }, undefined, {
            shallow: true,
            scroll: true
        });
    }, [
        searchParams
    ]);
    return {
        handleSubject,
        handleCategory,
        category,
        subject
    };
};
export default useCouponFilter;
